export interface IDonorPreselect {
    Id: number,
    donorId: number,
    recipientId: number,
    hardBlockSource: string,
    hardBlockReason: string,
    hardBlockComments: string,
    isAccepted: boolean,
    isFullyConfident: boolean,
    isGlobalDecline: boolean,
    isReEvalNeeded: boolean,
    decisionDateTime: string,
    userId: number,
    updatedDonorItems: string,
    singleEpletMmDr: number,
    singleEpletMmDq: number,
    singleEpletMmDqLow: number,
    totalEpletMmDr: number,
    totalEpletMmDrVerifiedAb: number,
    totalEpletMmDq: number,
    totalEpletMmDqVerifiedAb: number,
    epletMMRisk: string,
    donorPreselectDecision: string,
}